import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import Scene from './components/Scene';
import Hero from './sections/Hero';
import About from './sections/About';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Skills from './sections/Skills';
import Articles from './sections/Articles';
import Slides from './sections/Slides';
import Contact from './sections/Contact';
import './App.css';

function App() {
  return (
    <div className="portfolio-app">
      <div className="canvas-wrap">
        <Canvas
          camera={{ position: [0, 0, 12], fov: 60 }}
          dpr={[1, 2]}
          gl={{ antialias: true, alpha: true }}
        >
          <Suspense fallback={null}>
            <Scene />
          </Suspense>
        </Canvas>
      </div>

      <nav className="nav">
        <a href="#hero">Sreedeep</a>
        <a href="#about">About</a>
        <a href="#slides">Slides</a>
        <a href="#experience">Experience</a>
        <a href="#projects">Projects</a>
        <a href="#skills">Skills</a>
        <a href="#articles">Articles</a>
        <a href="#contact">Contact</a>
      </nav>

      <main className="main-scroll">
        <Hero />
        <About />
        <Slides />
        <Experience />
        <Projects />
        <Skills />
        <Articles />
        <Contact />
      </main>
    </div>
  );
}

export default App;
